import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import SessionClientResourceCenter from 'dashboard/lib/clients/SessionClientResourceCenter';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { showMessage } from 'dashboard/redux/actions/messages';
import { RootState } from 'dashboard/redux/store';
import { ApiEndpoint, ApiModel, ApiResource } from 'lib/interfaces/api';

interface WorkrampInstantAuthResponse {
  meta: {
    'login-url': string;
  };
}

const DashboardLoginWorkrampRoute = (props: PropsFromRedux) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchWorkrampAuth = async () => {
      const attributes = {
        'name-first': props.currentUser.attributes['name-first'] || '',
        'name-last': props.currentUser.attributes['name-last'] || '',
        email: props.currentUser.attributes['email-address'] || '',
      };

      try {
        const { meta } = await SessionClientResourceCenter.postResourceSingletonActionNew<
          ApiResource<null>,
          {
            type: ApiModel.WorkrampInstantAuth;
            attributes: { 'name-first': string; 'name-last': string; email: string };
          },
          WorkrampInstantAuthResponse
        >(ApiEndpoint.WorkrampInstantAuth, '', {
          attributes,
          type: ApiModel.WorkrampInstantAuth,
        });

        if (meta && meta['login-url']) {
          window.location.replace(meta['login-url']);
        } else {
          props.showMessage(
            'Sorry, something went wrong. Please reach out to support@withpersona.com.',
            MessageType.Failure,
          );
        }
      } catch {
        props.showMessage(
          'Sorry, something went wrong. Please reach out to support@withpersona.com.',
          MessageType.Failure,
        );
      }
    };

    if (SessionClientDashboard.isLoggedIn()) {
      fetchWorkrampAuth();
    } else {
      // Note: Setting the `from` is important so that once a user logs into Persona, they are redirected
      // back to `/dashboard/login-workramp` and then redirected to Workramp, instead of to the Persona Dashboard.
      navigate('/dashboard/login', { state: { from: location.pathname } });
    }
  }, [props.currentUser]);

  return <></>;
};

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: state.currentUser.currentUser,
  };
};

const mapDispatchToProps = {
  showMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardLoginWorkrampRoute);
